/**
 * Các store phía client (zustand…) đăng ký hàm reset tại đây.
 * Khi người dùng đổi / đăng xuất / hết phiên ⇒ gọi resetAll() để KHÔNG giữ thông tin tài khoản cũ.
 */
const resetters = new Set<() => void>();

export function registerReset(fn: () => void): void {
  resetters.add(fn);
}

export function resetAll(): void {
  resetters.forEach((fn) => fn());
}
